export default __webpack_public_path__ + "static/base-464363bf805163a563754ba209519706.png";